import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

type Props = {
    skip: number;
    limit: number;
};

export const getRefundRequests = async (skip: number, limit: number) => {
    try {
        const response = await Axios.get(`/refund-requests/list?skip=${skip}&limit=${limit}`);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(`${error.response.data?.meta?.message || "An error occurred"}`);
        }
        throw new Error(error.message || "Network Error");
    }
};

export const useGetRefundRequests = ({ skip, limit }: Props) => {
    const requests = useQuery({
        queryKey: ["get_refund_requests", skip, limit],
        queryFn: () => getRefundRequests(skip, limit),
    });

    return requests;
};
